<template>
  <div class="language-switcher">
    <!-- <div class="lang-container">
      <div v-for="(lang, i) in languages" :key="i" class="lang" @click="selectLocale(lang)">
        <span :class="{'active-language': lang.toLowerCase() === $i18n.locale}">{{ (appConfigDateFormats[lang.toLowerCase()] && appConfigDateFormats[lang.toLowerCase()].switcherDisplayName) || lang}}</span>
      </div>
    </div> -->
    <template v-if="!isMobileApp || (isMobileApp && userAgent !== 'ios')">
      <v-select v-model="$i18n.locale"  @click.stop="selectLocale(lang)" class="select_lang"
        @change="selectLocale($i18n.locale)"
        :items="availableLanguages"
        :label="''">
      </v-select>
    </template>
    <template v-if="isMobileApp && userAgent === 'ios'">
      <v-btn @click.stop="selectLocaleIOS()" class="select_lang">
        {{ (appConfigDateFormats[$i18n.locale.toLowerCase()] && appConfigDateFormats[$i18n.locale.toLowerCase()].switcherDisplayName) || lang}}
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
import { localeProperties, loadLanguageAsync } from '@/library/locale/i18n'
import store from '@/store'
import lib from '@/library'
import config from '@/config'
import mobileBridge from '@/library/mobileBridge'

export default {
  name: 'languageSwitcher',
  data () {
    return {
      languages: localeProperties.getSupportedLocales,
      locale: this.$i18n.locale,
      onMounted: false,
      isIOSLanguageSelectionMode: false
    }
  },
  computed: {
    appConfigDateFormats () {
      return config.app.appConfigDateFormats
    },
    availableLanguages () {
      var self = this
      var items = []
      for (var i = 0; i < self.languages.length; i++) {
        var item = {
          text: (this.appConfigDateFormats[self.languages[i].toLowerCase()] && this.appConfigDateFormats[self.languages[i].toLowerCase()].switcherDisplayName) || self.languages[i],
          value: self.languages[i].toLowerCase()
        }
        items.push(item)
      }
      return items
    },
    isMobileApp () {
      return window.ctsautoconf.MOBILE_LS || false
    },
    userAgent () {
      return lib.core.userAgent.os.name
    }
  },
  methods: {
    setLocaleOnPageLoad () {
      if (this.$i18n.locale !== this.locale) {
        this.onMounted = true
        this.locale = this.$i18n.locale
      }
    },
    selectLocale (lang) {
      if (lang.toLowerCase() !== this.locale) {
        this.locale = lang.toLowerCase()
      }
      if (this.isMobileApp) {
        mobileBridge.bridgeSendRequest('mobileSetLanguage', lang)
      }
    },
    selectLocaleIOS () {
      this.isIOSLanguageSelectionMode = true
      mobileBridge.bridgeSendRequest('mobileSetLanguage', this.locale)
    }
  },
  mounted () {
    setTimeout(() => {
      this.setLocaleOnPageLoad()
    }, 1000)
  },
  watch: {
    locale (newVal) {
      console.log('locale watch', newVal)
      if (newVal) {
        if (this.onMounted) {
          this.onMounted = false
          return false
        }
        if (this.isMobileApp && this.userAgent === 'ios' && this.isIOSLanguageSelectionMode) {
          this.isIOSLanguageSelectionMode = false
          return false
        }
        localStorage.userLocale = newVal
        store.commit('setLanguageChangeDetected', true)
        loadLanguageAsync(newVal)
        let to = this.$router.resolve({ params: {lang: newVal} })
        this.$router.push(to.location)
        return false
      }
    }
  }
}
</script>

<style lang="stylus">
.language-switcher
  display: flex
  flex-direction column
  h3.switcher-heading
    padding-left 0px
  .lang-container
    padding-left 0px
    display flex
    align-items: center
    flex-wrap: wrap
    .lang
      padding-right 20px
      display flex
      cursor pointer
      span
        color var(--language-switcher-text-color)
      span.active-language
        padding 3px 10px
        border-radius 5px
        background #ff671f
        font-weight normal
        color #fff

  .select_lang
    padding-top 0
    .v-messages
      display none
    .v-input__slot
      border var(--app-settings-option-border)
      border-radius 5px
      color var(--app-settings-select-color)
      background var(--app-settings-select-bgr)
      .v-select__selections
        color var(--app-settings-select-color)
        padding-left 10px
        justify-content: center
      &:before
      &:after
        display none
      .v-icon
        color var(--app-settings-arrow-color)
        &.primary--text
           color var(--app-settings-arrow-color) !important
      .v-select__selection--comma
        margin 0
    &.v-select.v-text-field input
      flex 0 !important
      padding 0 !important

.v-btn.select_lang
  border var(--app-settings-option-border)
  border-radius 5px
  color var(--app-settings-select-color)
  background var(--app-settings-select-bgr)
  width 100%
  margin 0
  padding 0
  position relative
  font-size 16px
  &:before
    display none
  .v-icon
    color var(--app-settings-arrow-color)
    position absolute
    right 0px
.v-menu__content
  .v-list
    background var(--app-settings-select-bgr)!important
  .v-select-list
    a
    .v-list__tile
      color: var(--app-settings-select-color) !important
</style>



// WEBPACK FOOTER //
// src/components/layout/parts/LanguageSwitcher.vue